import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { useEffect } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { EspecificidadeObra } from "../../../../domain/models/especificidade_obra";
import { EspecificidadeObraForm, EspecificidadeObraSchema } from "../../../schemas/Obras_informacoesgerais/especificidade_obra";

import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";

/**
 * EspecificidadeObraModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedEspecificidadeObra: EspecificidadeObra | null,
  onClose: () => void;
  onSubmit: (e: any) => void;
};

export const EspecificidadeObraModal = ({
  open,
  saving,
  loading,
  selectedEspecificidadeObra,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<EspecificidadeObraForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(EspecificidadeObraSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectedEspecificidadeObra) {
        hookForm.setValue('item', selectedEspecificidadeObra.descricao ?? '');
        hookForm.setValue('formaControle', selectedEspecificidadeObra.formaControle ?? '');
      } else {
        hookForm.reset({});
      }
    }
  }, [
    open,
    selectedEspecificidadeObra,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title={'Especificidade Obra'}
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <FormContainer title={"Informações"} arrangement="fullRow">
        <>
          <DefaultFormInput
            name='item'
            label='Item'
            multiline={true}
            minRows={8}
            required={true}
            reactHookForm={hookForm} />

          <DefaultFormInput
            name='formaControle'
            label='Forma de Controle'
            multiline={true}
            minRows={8}
            required={true}
            reactHookForm={hookForm} />
        </>
      </FormContainer>
    </BaseFormControlledModal>
  );
}